import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../../utils/endpoints';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOnboardingData,
    setOnboardingData
} from '../../../../redux/onboardingSlice';
import { http_put } from '../../utils/api_client';

export const UserFormTitle = () => (
    <div>
        <h1 className="un-auth__q">What's your name?</h1>
        <p className="un-auth__sub">So we can personalize your workspace.</p>
    </div>
);

const UserForm = ({ onChangeStep }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => getOnboardingData(state));
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [error, setError] = useState(null);

    const saveBio = () => {
        setIsLoading(true);
        setError(null);
        http_put(API_ENDPOINTS.PUT_PROFILE, {
            first_name: data.firstName,
            last_name: data.lastName
        })
            .then(() => onChangeStep())
            .catch((err) => {
                setError(err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.');
            })
            .finally(() => setIsLoading(false));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(setOnboardingData({ [name]: value }));
    };

    useEffect(() => {
        setIsDisabled(!(data.firstName && data.lastName));
    }, [data]);

    return (
        <>
            <div className="un-auth__field">
                <div className="un-auth__label">First name</div>
                <input type="text" name="firstName" placeholder="Jordan" value={data.firstName || ''} onChange={handleChange} />
            </div>
            <div className="un-auth__field">
                <div className="un-auth__label">Last name</div>
                <input type="text" name="lastName" placeholder="Rivera" value={data.lastName || ''} onChange={handleChange} />
            </div>
            {error && <p className="un-auth__err" role="alert">{error}</p>}
            <button className="un-auth__btn un-auth__btn--primary" onClick={saveBio} disabled={isDisabled || isLoading}>
                {isLoading ? 'Saving…' : 'Continue'}
            </button>
        </>
    );
};

export default UserForm;
